import script from "./Model.vue?vue&type=script&setup=true&lang=js"
export * from "./Model.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__